export function useQueryInput(input: globalThis.Ref, queryString: string) {
  const route = useRoute()

  const query = new URLSearchParams(route.query as any)
  const value = query.get(queryString) ?? ''

  input.value = value

  return {
    value
  }
}
